<div class="wrapper">
    <div class="close-btn" >
        <mat-icon (click)="close()">close</mat-icon>
    </div>
    
    <mat-dialog-content>
        <div class="dialog-content">
            <i class="icon" [ngClass]="getIconClass()"></i>
            <span class="text" [innerHTML]="data?.body"></span>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button class="bciti-button no-transition bciti-button--dark" (click)="onButtonClick()">
            {{ data?.buttonText ?? ('common.close' | translate) }}
        </button>
    </mat-dialog-actions>
</div>
